const findStepApp = (step, apps = []) => {
  return apps?.find((n) => n?.id === step?.appId && String(n?.version) === String(step?.appVersion || '0'));
};

export default findStepApp;
